import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActionService } from 'src/app/services/action/action.service';
import { EventTransportService } from 'src/app/services/event-transport/event-transport.service';

@Component({
    selector: 'app-sign-message',
    templateUrl: './sign-message.component.html',
    styleUrls: [ './sign-message.component.scss' ],
})
export class SignMessageComponent implements OnInit
{
    @Input('msg') msgToSign: string;
    @Input('address') walletAddress: string;

    @Output() hideEvent = new EventEmitter();

    public loading: boolean = false;
    public failDescription: string;
    private eventSubscription: Subscription;

    constructor(
        private eventTransport: EventTransportService,
        private actionService: ActionService
    ) { }

    public async confirmSign()
    {
        this.eventTransport.send('signMsg-confirmation', { result: true });
        this.loading = true;
        // this.back();
    }

    public denySign()
    {
        this.eventTransport.send('signMsg-confirmation', { result: false });
        this.back();
    }

    public back()
    {
        this.hideEvent.emit(false);
    }

    ngOnInit(): void
    {
        this.msgToSign = this.msgToSign//.replace('\n', '<br/>');
        console.log(this.msgToSign);
        this.eventSubscription = this.eventTransport
            .on('sign-result')
            .subscribe(async (_data) =>
            {
                if (!!_data) this.processSignResult(_data.data);
            });
    }

    private processSignResult(data)
    {
        if (data.result)
        {
            this.back();
        } else
        {
            this.loading = false;
            this.failDescription = data.description;
            this.back();
        }
    }
}
